import React from 'react'

const coding_data = [
    {
        name: ".Net / C#",
        skillPer: "90"
    },
    {
        name: "MVC",
        skillPer: "65"
    },
    {
        name: "JavaScript / jQuery",
        skillPer: "85"
    },
    {
        name: "React",
        skillPer: "40"
    },
    {
        name: "HTML / CSS",
        skillPer: "80"
    },
    {
        name: "SQL",
        skillPer: "65"
    }
]

export default coding_data;